import { Pipe, PipeTransform } from '@angular/core';

import { ENavbarItemType, NavbarLink, TNavigation } from '@app/shared/components/under-ui-header/types/navbar-item.type';

export function matchesPrefix(currentUrl: string, path: string): boolean {
  const urlPath = currentUrl.split('?')[0];
  const normalized = path.startsWith('/') ? path : '/' + path;
  return urlPath === normalized || urlPath.startsWith(normalized + '/');
}

/**
 * A link owns the current URL when its path (or `activePath`) is a prefix of it and no
 * `excludePaths` entry is a closer match — that is how a broad entry (`/captives`) hands a
 * nested branch (`/captives/prospects`) over to its own sibling entry.
 */
export function isLinkActive(currentUrl: string, link: NavbarLink): boolean {
  if (link.excludePaths?.some(excluded => matchesPrefix(currentUrl, excluded))) {
    return false;
  }

  return matchesPrefix(currentUrl, link.activePath ?? link.path);
}

@Pipe({
  name: 'isChildActive',
  standalone: true,
  pure: true,
})
export class IsChildActivePipe implements PipeTransform {
  transform(child: TNavigation, currentUrl: string, activeOverride: string | null = null): boolean {
    if (child.type !== ENavbarItemType.Link) {
      return false;
    }

    if (activeOverride) {
      return child.path === activeOverride;
    }

    return isLinkActive(currentUrl, child);
  }
}
